/* eslint-disable react/jsx-key */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useNavigate, useParams } from 'react-router-dom';
import Styles from './styles';
import ForgotScreenBG from '../../assets/images/Forgot-Screen-BG.png';
import InputField from './InputField/InputField';
import ShowPassword from '../../assets/svg/ShowPassword';
import HidePassword from '../../assets/svg/HidePasssword';
import Button from '../../components/Button';
import OTPInput from './OTPInput/OTPInput';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

const endPoint = process.env.REACT_APP_API_BASE_URL;

export function PasswordStrengthBar({ password }) {
  const calculateStrength = () => {
    const { length } = password;
    let strength = 0;

    // Check length and numbers
    if (length >= 8 && /[0-9]/.test(password)) {
      strength += 1;
    }
    // Check for uppercase and lowercase characters
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) {
      strength += 1;
    }

    // Check for special characters
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      strength += 1;
    }
    return strength;
  };

  const strength = calculateStrength();

  return (
    <div>
      {password ? (
        <Grid container style={{ marginBottom: '1.5rem', gap: 9 }}>
          {strength >= 0 && (
            <Grid
              item
              xs={4}
              style={{
                maxWidth: '96px',
                height: '5px',
                borderRadius: '15px',
                backgroundColor: '#E87466',
              }}
            />
          )}
          {strength >= 1 && (
            <Grid
              item
              xs={4}
              style={{
                maxWidth: '96px',
                height: '5px',
                borderRadius: '15px',
                backgroundColor: '#FFDB9B',
              }}
            />
          )}
          {strength > 2 && (
            <Grid
              item
              xs={4}
              s
              style={{
                maxWidth: '96px',
                borderRadius: '15px',
                height: '5px',
                backgroundColor: '#9AE68B',
              }}
            />
          )}
        </Grid>
      ) : null}
    </div>
  );
}

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #e3f0ff;
  border-radius: 20px;
  width: 100%;
  padding: 0px 0px;
  box-sizing: border-box;
  height: 100%;
`;

const NewPaper = styled.div`
  width: 576px;
  background-color: white;
  border-radius: 0px 18px 18px 0px;
  border-right: 29px solid #14645d;
  opacity: 0.95;
  padding-bottom: 100px;
  margin-top: 27px;
  @media (max-width: 1001px) {
    padding-bottom: 30px;
  }
  @media (max-width: 768px) {
    width: 400px;
    border-right-width: 20px;
    padding-bottom: 100px;
  }
`;

const NewCard = styled.div`
  @media (max-width: 768px) {
    width: 400px;
    border-right-width: 20px;
  }
`;

const NewInputField = styled(InputField)`
width: '412px',
border: '1px solid #EDEBEB',
background: '#F2F2F2',
borderRadius: '4px',
@media (max-width: 768px) {
  width: 200px;
}
`;

const BtnController = styled.div`
  margin-top: 20px;
  @media (max-width: 767px) {
    margin-top: 20px;
  }
`;

const LeftContainer = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

function ChangePassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { memberId, authToken } = useParams();
  const navigate = useNavigate();

  // Toggle password for New Password Field
  const [showNewPassword, setShowNewPassword] = useState(false);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleMouseDownNewPassword = () => setShowNewPassword(!showNewPassword);
  const [Otp, setOtp] = useState('');

  // Toggle password for Confirm New Password Field
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleMouseDownConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
  };

  const handleCopy = (e) => {
    e.preventDefault();
  };

  const handlePaste = (e) => {
    e.preventDefault();
  };

  // eslint-disable-next-line consistent-return
  const postData = async () => {
    try {
      if (!Otp) {
        toast.error('Please enter OTP');
        return;
      }
      const data = {
        newPassword,
        memberId,
        otp: Number(Otp),
      };

      const response = await fetch(`${endPoint}/updatePasswordByOtp`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': authToken,
        },
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (response.ok) {
        toast.success('Password updated successfully');
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        const responseData = await response.json();
        toast.error(
          responseData.message ||
            'Something went wrong. Please contact support.'
        );
      }
    } catch (err) {
      const responseData = await err.json();
      toast.error(
        responseData.message || 'Something went wrong. Please contact support.'
      );
      console.log('error', err);
    }
  };

  // validation of Change Password screen
  const check = (e) => {
    if (newPassword === '') {
      toast.error('New Password can not be Empty');
    } else if (newPassword.length < 8) {
      toast.error('Please enter at least 8 characters');
    } else if (confirmPassword === '') {
      toast.error('Please confirm your Password');
    } else if (confirmPassword !== newPassword) {
      toast.error('Confirm password does not match');
    } else {
      postData(e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    check(e);
  };
  const TITLE = 'New User / Forgot Password - BSG Contribution Site';
  return (
    <MainContainer>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: `url(${ForgotScreenBG})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh',
        }}
      >
        <Box
          style={{
            padding: '15px 45px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LeftContainer>
            <NewCard>
              <div style={Styles.cardStyle}>
                <div style={Styles.cardContainer}>
                  <Box style={{ marginBottom: 20 }}>
                    <Typography style={Styles.cardHeadingTypography}>
                      Tips for creating a strong password.
                    </Typography>
                  </Box>

                  <Typography style={Styles.cardMessageTypography}>
                    Creating a strong and secure password is an important part
                    of protecting your BSG Account.
                  </Typography>
                  <Typography style={Styles.cardMessageTypography}>
                    Here are some tips for creating a strong password :
                  </Typography>
                </div>
                <Box
                  style={{
                    marginTop: 25,
                    marginLeft: '3rem',
                    color: '#FFFFFF',
                  }}
                >
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: '#FFFFFF' }} />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ maxWidth: '305px' }}
                      primary="Use at least 8 characters "
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: '#FFFFFF' }} />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ maxWidth: '305px' }}
                      primary="Use a mix of letters (uppercase and lowercase), numbers and symbols "
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: '#FFFFFF' }} />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ maxWidth: '305px' }}
                      primary="Don't use your name, username or account name "
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: '#FFFFFF' }} />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ maxWidth: '305px' }}
                      primary='Avoid predictable passwords such as "BSG123#"'
                    />
                  </ListItem>
                </Box>
              </div>
            </NewCard>
          </LeftContainer>
          <NewPaper>
            <form onSubmit={handleSubmit}>
              <div style={Styles.divContainer}>
                <Typography
                  style={{ ...Styles.typographyHeading, color: '#009cbf' }}
                >
                  Change Password
                </Typography>
                <Typography style={Styles.typographyMessage}>
                  Enter the OTP we just sent to your registered email and mobile
                  number.
                </Typography>
                <div
                  style={{
                    width: '250px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '1rem',
                  }}
                >
                  <OTPInput
                    onOTPChange={handleOTPChange}
                    style={{
                      height: 40,
                      background: '#F2F2F2',
                      fontSize: 16,
                      color: '#00000',
                    }}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <NewInputField
                    required
                    label="New Password"
                    name="newPassword"
                    Placeholder="New Password"
                    sx={{ marginBottom: '20px' }}
                    type={showNewPassword ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onCopy={handleCopy}
                    onPaste={handlePaste}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowNewPassword}
                            onMouseDown={handleMouseDownNewPassword}
                          >
                            {showNewPassword ? (
                              <ShowPassword />
                            ) : (
                              <HidePassword />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div style={newPassword ? { marginTop: '-1.8rem' } : {}}>
                    <PasswordStrengthBar password={newPassword} />
                  </div>
                </div>

                <NewInputField
                  required
                  label="Confirm New Password"
                  name="confirmPassword"
                  Placeholder="Confirm New Password"
                  sx={{ marginBottom: '20px' }}
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  onCopy={handleCopy}
                  onPaste={handlePaste}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownConfirmPassword}
                        >
                          {showConfirmPassword ? (
                            <ShowPassword />
                          ) : (
                            <HidePassword />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <BtnController>
                  <Button
                    variant="contained"
                    label="Change Password"
                    type="submit"
                  >
                    Change Password
                  </Button>
                </BtnController>
              </div>
            </form>
          </NewPaper>
        </Box>
      </Box>
    </MainContainer>
  );
}

export default ChangePassword;
